<template>
  <v-navigation-drawer v-model="getMouseState" absolute temporary right>
    <v-list>
      <v-list-item-title align="center" class="" style="font-size: 30px">
        Total price
      </v-list-item-title>
      <v-list-item-subtitle align="center">
        <v-btn class="ma-2" outlined color="green">
          ${{ cartTotalPrice.toFixed(2) }}
        </v-btn>
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="!cartHasProducts" align="center">
        Your cart is empty.
      </v-list-item-subtitle>
    </v-list>
    <v-divider></v-divider>
    <v-list>
      <v-list-item v-for="item in cart" :key="item.id">
        <v-card class="mx-auto mb-2" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div
                class="overline mb-4"
                :class="[
                  item.productVariant.available ? 'green--text' : 'red--text'
                ]"
              >
                {{ isAvailable(item) }}
              </div>
              <v-list-item-title class="headline mb-1">
                ${{ item.productVariant.price }}
              </v-list-item-title>
              <v-list-item-subtitle
                >weight-{{ item.productVariant.weight }}</v-list-item-subtitle
              >
            </v-list-item-content>

            <v-badge color="green" :content="item.quantity">
              <v-list-item-avatar tile size="80">
                <v-img :src="item.productVariant.image.src"></v-img>
              </v-list-item-avatar>
            </v-badge>
          </v-list-item>

          <v-card-text>
            {{ item.productVariant.title }}
          </v-card-text>
        </v-card>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CartSideBar",
  props: {
    mouseState: {
      type: Boolean,
      default: false,
      description: "Open the cart sidebar"
    }
  },
  computed: {
    ...mapGetters(["cart", "cartHasProducts"]),
    getMouseState: {
      get() {
        return this.mouseState;
      },
      set(newValue) {
        return newValue;
      }
    },
    cartTotalPrice() {
      return this.cartHasProducts === true
        ? this.cart.reduce((reducer, item) => {
            if (item.productVariant) {
              return reducer + item.productVariant.price * item.quantity;
            } else {
              return 0.0;
            }
          }, 0)
        : 0.0;
    }
  },
  methods: {
    isAvailable(item) {
      return item.productVariant.available === true
        ? "available"
        : "unavailable";
    }
  }
};
</script>
